module.exports = __webpack_public_path__ + "static/media/bm.7d91827f.svg";